import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: 420,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16,
        padding: "32px 24px",
        overflow: "auto"
      }
    },
    dialogTitle: {
      padding: 0,
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    },
    mainTitle: {
      color: theme.palette.error.light
    },
    dialogCenter: {
      padding: "0px !important",
      margin: "24px 0 32px 0 !important"
    },
    dialogFooter: {
      borderTop: 0,
      padding: 0,
      justifyContent: "space-between",
      gap: 16,
      "& button": {
        width: "100%",
        margin: "0 !important"
      },
      "& .MuiTypography-root": {
        color: "inherit"
      }
    },
    btnClose: {
      height: "48px"
    }
  }),
  { name: "InputParameter" }
);

interface ModalConfirmDeleteItemProps {
  open: boolean;
  onClose: () => void;
  submitData: () => void;
}

const ModalConfirmDeleteItem: React.FC<ModalConfirmDeleteItemProps> = ({
  open,
  onClose,
  submitData
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Dialog className={classes.root} open={open} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        <MyTypography variant="h6" className={classes.mainTitle}>
          Delete รายการที่เลือก
        </MyTypography>
      </DialogTitle>
      <DialogContent className={classes.dialogCenter}>
        <MyTypography variant="body2">
          กรุณากด “ยืนยัน” เพื่อลบรายการที่เลือก หรือกด “กลับไป”
          เพื่อปิดหน้าต่างนี้
        </MyTypography>
      </DialogContent>
      <DialogActions className={classes.dialogFooter}>
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          className={classes.btnClose}
        >
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "กลับไป" })}
          </MyTypography>
        </Button>
        <Button variant="contained" color="primary" onClick={submitData}>
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "ยืนยัน" })}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmDeleteItem;
